<div id="hero-container">
  <ng-container *appShowOnMobileOrTablet>
    <img
      *appFadeInOnScroll
      alt=""
      class="fadeInit flipAndScaleUp"
      height="300"
      id="hero_img"
      src="/multimedia/home/szebit_round.webp"
      width="300"
    />
  </ng-container>
  <ng-container *appShowOnDesktop>
    <div class="glow" id="hero_glow"></div>
    <p id="hero_date">{{ szebitDateHu }}</p>
    <video
      autoplay
      id="video_background"
      loop
      muted
      oncanplay="this.play()"
      onloadedmetadata="this.muted = true"
      playsinline
      preload=""
      width="100%"
    >
      <source src="/multimedia/home/hero_video_2026.mp4" type="video/mp4" />
      <track kind="subtitles" />
    </video>
  </ng-container>
</div>
